module.exports = __webpack_public_path__ + "static/media/icon.3c2e89f4.png";